import styled from "styled-components";

function Proceed({
    className,
    percentage
}) {
    return (<ProceedStyledWrapper className={"proceed-bar " + className}>
        <div className="proceed-container">
            <div className="proceed" style={{
                width: percentage + "%"
            }}></div>
        </div>
        <div className="percentage">
            {percentage.toFixed(0) + "%"}
        </div>
    </ProceedStyledWrapper>);
}

export default Proceed;

const ProceedStyledWrapper = styled.div`
        .proceed-container{
            height:1.5rem;
            flex-grow: 1;
            border-radius: 99rem;
            background-color:#efefef;
            margin-right: 1.4rem;
            .proceed{
                background-color: #000;
                height:100%;
                border-radius: 99rem;
            }
        }
        .percentage{
            font-size:1.8rem;
            flex-shrink: 0;
        }
`;